module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgB7ZZBCoMwEEWnWXiO1JXX8ORew5XNMcSF1CkUJCidMR9K2v82EXGSp04yI0IIIYT8Mjfrg23bPnRsmqYfxzEJgLgRQhj0epqmuyUmiI+4LMvQdV2UQnay0RNnFl7Xtd+GJADpTDbpX7PGmlPibCFvepTO4RIuXRDxwm7hqwsjZJVLwl4BlKxyWdgqgpRVioQ/CaFllWJhORGb51nQsgpEWMml37cFKKvAhJWD6gWVVbyl+etUlxKQL3y06ZC9x57/OtaqKhxVleaqmp+q2suqGnhkHpbMZT6HkTs9beTntDXWWzhgVSuTJoQQQsiLJ7Ee/TdsyvgXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/c31/close_button.png
// module id = +PZA
// module chunks = 0